import * as svg from "../../../assets/chatgpt-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ChatGptIcon = iconBuilder(svg, "ChatGptIcon", "0 0 12 12");
